import React from "react";
import styled from "styled-components";
import { sectionPopulationColor } from "./../../Util/Colors";
import { maxWidthBlock } from "./../../Util/StyleProps";
import { Container as BsContainer } from "react-bootstrap";
import { device } from "./../../Util/Breakpoints";

const Wrapper = styled.div`
  margin:0 auto !important;
  padding:0 24px;

  @media${device.mobileL}{
    padding: 0 24px;
  }
  @media${device.tablet}{
    max-width: ${props => (props.maxWidth ? props.maxWidth : "100%")};
    padding: 0 32px;
  }
  > svg {
    margin-top: 48px;
    @media${device.tablet} {
      margin-top: 64px;
    }
  }
`;
const StyledContainer = styled(BsContainer)`
  margin:  ${props => props.marginMobile || "0 0 24px 0"};
  padding-bottom: ${props => props.paddingBottom || "48px"};
  @media${device.tablet} {
   padding-bottom: ${props => props.paddingBottom || "80px"};
    margin: ${props => props.margin || "0"};
  }
`;

const BlockLayout = props => {
  const {
    children,
    background,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    margin,
    marginMobile,
    maxWidth,
    borderRadius,
    height
  } = props;
  return (
    <StyledContainer
      fluid
      style={{
        background: background,
        paddingTop,
        paddingRight,
        paddingLeft,
        borderRadius,
        height
      }}
      paddingBottom={paddingBottom}
      margin={margin}
      marginMobile={marginMobile}
    >
      <Wrapper maxWidth={maxWidth}>{children}</Wrapper>
    </StyledContainer>
  );
};

BlockLayout.defaultProps = {
  background: { sectionPopulationColor },
  maxWidth: maxWidthBlock,
  paddingTop: "0",
  margin: "0 0 32px 0",
  borderRadius: "24px",
  paddingLeft: "0",
  paddingRight: "0",
  height: "auto"
};

export default BlockLayout;
